import { useAuthContext } from '@pata-app/ui-auth';
import { Header, Footer } from '@pata-app/ui-document';
import { useLoginModalContext } from '@pata-app/ui-login-modal';

import React, { useEffect } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

import { useGetUserDetails } from '../../hooks/useGetUserDetails';
import { getEnv } from '../../lib/utils/getEnv';
import { MainContainer } from './appWrapper.styled';
import { IAppWrapper } from './appWrapper.types';

if (typeof window !== 'undefined') {
  import('react-toastify/dist/ReactToastify.css');
}

const { VITE_CDN_BASE_URL_USER_CONTENT, VITE_WEB_BASE_URL, VITE_PARTNERS_BASE_URL } = getEnv();

function getImageUrl(imagePath?: string | null) {
  if (!imagePath) return '';

  if (imagePath.includes('googleusercontent')) {
    return imagePath;
  }

  return `${VITE_CDN_BASE_URL_USER_CONTENT}/${imagePath}`;
}

const AppWrapper = ({ children }: IAppWrapper) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const hasSignupModalParam = searchParams.get('auth-modal');

  const location = useLocation();

  const { isAuthenticated, logout, isAuthLoading } = useAuthContext();
  const { setIsOpen } = useLoginModalContext();

  useEffect(() => {
    if (hasSignupModalParam && !isAuthenticated && !isAuthLoading) {
      setIsOpen('register');

      searchParams.delete('auth-modal');
      setSearchParams(searchParams);
    }
  }, [hasSignupModalParam, isAuthenticated, isAuthLoading]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const handleLogout = async () => {
    await logout({ global: true });

    window.location.reload();
  };

  const { data } = useGetUserDetails();

  const user = data?.data?.data;

  const userInfo = {
    firstName: user?.firstName,
    lastName: user?.lastName,
    imageUrl: getImageUrl(user?.profilePicture),
  };

  return (
    <>
      <Header
        domain=""
        isAuthenticated={isAuthenticated}
        isAuthLoading={isAuthLoading}
        userInfo={userInfo}
        onLogoutPress={handleLogout}
        onSignupPress={() => setIsOpen('register')}
        onLoginPress={() => setIsOpen('login')}
        partnerAppLink={location.pathname.includes('business') ? VITE_PARTNERS_BASE_URL : undefined}
        baseUrl={VITE_WEB_BASE_URL}
      />
      <MainContainer>{children}</MainContainer>
      <ToastContainer
        autoClose={5000}
        closeOnClick
        hideProgressBar
        newestOnTop={false}
        pauseOnFocusLoss
        pauseOnHover
        position="bottom-right"
        rtl={false}
        theme="dark"
      />
      <Footer baseUrl={VITE_WEB_BASE_URL} />
    </>
  );
};

export default AppWrapper;
